import messagesEnUs from 'assets/compiled-lang/en-US.json';

export const localesByKey = {
  EN_US: 'en-US',
};

export const messagesByLocaleKey = {
  [localesByKey.EN_US]: messagesEnUs,
};
